import { api } from '@setplex/tria-api'
import { createEvent, sample } from 'effector'

export enum ContentType {
  All = 'all',
  Movies = 'movies',
  TvShows = 'shows',
  TvChannels = 'tv',
  Events = 'events',
}

const INIT_PAGE_NUMBER = 0
const INIT_GRID_ELEMENTS_COUNT = 36

// Events

export const init = createEvent<{
  contentType?: ContentType
  query: URLSearchParams
}>()
export const initRecommendedVodsPage = createEvent<{
  contentType?: ContentType
  query: URLSearchParams
}>()
export const initSearchResultsPage = createEvent<{
  contentType?: ContentType
  query: URLSearchParams
}>()

export const searchInit = createEvent<{
  contentType?: ContentType
  query: URLSearchParams
}>()

sample({
  clock: [init, initSearchResultsPage],
  target: searchInit,
})

sample({
  clock: initRecommendedVodsPage,
  fn: () => ({ page: INIT_PAGE_NUMBER, count: INIT_GRID_ELEMENTS_COUNT }),
  target: api.vods.loadRealRecommendedVodsFx,
})
